/**
 * Menu Service Layer - 业务逻辑层 + Mock 适配
 */

import { config } from '../../config';
import * as menuMock from '../../mocks/menu';
import type { ApiResponse } from '../../types/common';
import type { MenuNode, GetMenuTreeRequest, CreateMenuRequest } from '../../types/menu';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';

/**
 * 获取菜单树
 */
export async function getMenuTree(params: GetMenuTreeRequest): Promise<ApiResponse<MenuNode[]>> {
  if (config.mock) {
    return menuMock.mockGetMenuTree(params);
  }

  const { appDomain, currentPage, pageSize } = params;
  const queryParams = new URLSearchParams();
  if (appDomain) queryParams.append('appDomain', appDomain);
  if (currentPage) queryParams.append('currentPage', currentPage.toString());
  if (pageSize) queryParams.append('pageSize', pageSize.toString());

  return httpClient.get(`${API_ENDPOINTS.MENU.TREE}?${queryParams.toString()}`);
}

/**
 * 创建菜单
 */
export async function createMenu(data: CreateMenuRequest): Promise<ApiResponse<MenuNode>> {
  if (config.mock) {
    return menuMock.mockCreateMenu(data);
  }

  return httpClient.post(API_ENDPOINTS.MENU.CREATE, data);
}

/**
 * 更新菜单
 */
export async function updateMenu(
  data: CreateMenuRequest & { id: number }
): Promise<ApiResponse<MenuNode>> {
  if (config.mock) {
    return menuMock.mockUpdateMenu(data);
  }

  return httpClient.post(API_ENDPOINTS.MENU.UPDATE, data);
}

/**
 * 删除菜单
 */
export async function deleteMenu(id: number): Promise<ApiResponse<void>> {
  if (config.mock) {
    return menuMock.mockDeleteMenu(id);
  }

  return httpClient.post(API_ENDPOINTS.MENU.DELETE, { id });
}
